import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const Container = styled.div`
  padding: 12px;
  border-radius: 8px;
  background-color: ${colors.gray100};
`;
